import FetchClient, { type ApiResponse } from "./FetchClient";

// Mirrors the report written by server/cmd/search-harvest (-s3).

export interface SearchHarvestHit {
  retailer: string;
  code: string;
  barcode?: string;
  name: string;
  image?: string;
  storeId: string;
  storePrice: number;
  refPrice: number;
  discountPct: number;
  stock: number;
  aisle?: string;
  source: "search" | "rescan";
  zip?: string;
  activeStore: boolean;
  inCatalog: boolean;
  added: boolean;
  saveError?: string;
  at: number;
}

export interface SearchHarvestRetailerSummary {
  activeStores: number;
  searches: number;
  freshSearches: number;
  uniqueItems: number;
  searchHits: number;
  rescanHits: number;
  hitsAtFollowed: number;
  newRows: number;
  gaps: number;
  known: number;
  coveragePct: number;
}

export interface SearchHarvestTopItem {
  code: string;
  name: string;
  image?: string;
  searches: number;
  bestPct: number;
  hits: number;
}

export interface SearchHarvestGapItem {
  code: string;
  name: string;
  image?: string;
  bestPct: number;
  bestPrice: number;
  refPrice: number;
  stores: string[];
  knownStores: number;
}

export interface SearchHarvestGapStore {
  storeId: string;
  label: string;
  gaps: number;
  known: number;
}

export interface SearchHarvestReport {
  generatedAt: string;
  windowStart: string;
  days: string[];
  minPct: number;
  retailers: Record<string, SearchHarvestRetailerSummary>;
  rescan: { areas: number; candidates: number; planned: number; lookups: number; errors: number; notFound: number; stopped?: string };
  rescanToday?: { lookups: number; errors: number; hits: number };
  topSearched: Record<string, SearchHarvestTopItem[] | null>;
  hits: SearchHarvestHit[] | null;
  gaps: Record<string, { items: SearchHarvestGapItem[] | null; stores: SearchHarvestGapStore[] | null }>;
}

export async function getSearchHarvestReport(refresh = false): Promise<SearchHarvestReport | null> {
  const response = await FetchClient.get<ApiResponse<SearchHarvestReport>>(`/admin/search-harvest${refresh ? "?refresh=1" : ""}`);
  return response.data ?? null;
}
